import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Compponents/Navbar/Navbar'
import Header from '../Compponents/Header/Header'
import Footer from '../Compponents/Footer/Footer'
export default function 
() {
  return (
    <div>
        <Navbar/>
        <Header/>

        <Outlet/>
        <Footer/>
    </div>
  )
}
